// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"ed424e94","917":"f6facd8d"}[chunkId] + ".chunk.js";
};